module.exports = __webpack_public_path__ + "static/media/gsuite-spark-cards.36fa7718.png";